import tickerObserver from '../../utils/ticker/ticker-observer';

const PLACEHOLDER_EMPTY_VALUE = '–';

const UNDERLYING_DEFAULTS = {
	name: PLACEHOLDER_EMPTY_VALUE,
	url: '#',
	id: '',
	referencePriceFormatted: PLACEHOLDER_EMPTY_VALUE,
	currencyCode: PLACEHOLDER_EMPTY_VALUE,
};

const renderHeader = ({ url, name }) => `
	<h2 class="trailer-reset">
		<a href="${url}">${name}</a>
	</h2>
`;

const renderTicker = ({ id, referencePriceFormatted, currencyCode } = {}) => `
	<div class="quote quote--inline" data-underlying-key="${id}" data-feed-property="ReferencePrice" data-has-indicator="true">
		<span class="quote__value" data-ref="value">${referencePriceFormatted}</span>
		<span class="quote__info">${currencyCode}</span>
	</div>
`;

class TurbomapHeader {
	constructor(el) {
		this.el = el;

		this.underlying = { ...UNDERLYING_DEFAULTS };

		this.update();
	}

	update(underlying = {}) {
		this.underlying = { ...UNDERLYING_DEFAULTS, ...underlying };

		this.render();
	}

	render() {
		tickerObserver.removeTickers(this.el);

		const result = `
			${renderHeader(this.underlying)}
			${renderTicker(this.underlying)}`;

		this.el.innerHTML = result;

		tickerObserver.addTickers(this.el);
	}
}

export default TurbomapHeader;
